import { AdminTheme } from '@va/aaas/shared/types';
import { createSelector } from 'reselect';

export const getTheme = (state: any) => (state.getIn(['app'])?.theme as AdminTheme) ?? {};

export const getAccountLogo = createSelector(getTheme, (theme) => theme.accountLogo);

export const isTopBarHidden = createSelector(getTheme, (theme) => theme.hideHeader);
